import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faVimeo } from "@fortawesome/free-brands-svg-icons";

const AboutMe = () => {
  return (
    <section
      id="about-me"
      className="bg-white text-gray-800 py-20 px-6 sm:px-8 lg:px-12"
    >
      <div className="max-w-3xl mx-auto text-left">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight leading-snug text-gray-900 mb-6">
          Jasmine Lopez Vieyra
        </h1>

        <div className="space-y-5 text-base md:text-lg leading-relaxed text-gray-700">
          <p>
            Photographer and producer based in Los Angeles. My eye for detail lives in everything I touch — from behind the camera to behind the scenes. I'm drawn to the moments that deserve to be remembered, the ones that would otherwise go unseen. On the production side, I take pride in assembling the right team for every project — people whose strengths and expertise serve the vision and whose standards match mine. Attention to detail and professionalism guide everything from pre-production through final delivery. Rooted in a childhood where access to family history was limited, preserving visual stories isn't just work for me — it's personal.
            
            <br/>
            
            Let's work.

          </p>
        </div>

          <div className="mt-10">
            <h2 className="text-sm uppercase tracking-wide font-semibold text-gray-500 mb-3">
              Follow My Work
            </h2>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 group">
                <FontAwesomeIcon
                  icon={faInstagram}
                  className="w-5 h-5 text-lime-700 group-hover:text-lime-900 transition"
                />
                <a
                  href="https://www.instagram.com/jas.lo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base font-medium text-gray-700 group-hover:underline"
                >
                  Instagram
                </a>
              </li>
              <li className="flex items-center gap-3 group">
                <FontAwesomeIcon
                  icon={faVimeo}
                  className="w-5 h-5 text-lime-700 group-hover:text-lime-900 transition"
                />
                <a
                  href="https://vimeo.com/user215090412"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base font-medium text-gray-700 group-hover:underline"
                >
                  Vimeo
                </a>
              </li>
            </ul>
          </div>
      </div>
    </section>
  );
};

export default AboutMe;
